import { ENDPOINT_CHAT, ENDPOINT_CHAT_HISTORY, ENDPOINT_SERVER } from "./SDK";

export const SDK_API = {
   BELIVE_LOGIN: `${ENDPOINT_SERVER}/users/login`,
   GUEST_LOGIN: `${ENDPOINT_SERVER}/users/guest-login`,
   CHECK_LOGIN: `${ENDPOINT_SERVER}/users/check-login`,
   /**
    * Event:
    */
   GET_EVENTS_BY_MONTH: `${ENDPOINT_SERVER}/events`,
   EVENT_DETAIL: `${ENDPOINT_SERVER}/events/detail`,
   JOIN_EVENT: `${ENDPOINT_SERVER}/events/join`,
   LEAVE_EVENT: `${ENDPOINT_SERVER}/events/leave`,

   /**
    * Configs:
    */
   NAUGHTY_WORDS: `${ENDPOINT_SERVER}/settings/naughty-words`,

   //Stream
   GET_STREAM_DETAIL: `${ENDPOINT_SERVER}/stream/detail`,
};

export const CHAT_APIs = {
   GET_CHAT_CHANNEL: `${ENDPOINT_CHAT}/viewers/getmychannel`,
   UPDATE_CHAT_CHANNEL: `${ENDPOINT_CHAT_HISTORY}/savechat`,
   GET_STATISTIC_CHANNEL: `${ENDPOINT_CHAT}/viewers/getStatistic`,
   UPDATE_LIKE_AMOUNT: `${ENDPOINT_CHAT}/viewers/addLikeAmount`,
   TRACKING_LIKE_ENDPOINT: `${ENDPOINT_SERVER}/events/likestream`,
   /**
    * Tracking user join
    */
   USER_JOIN_STREAM: `${ENDPOINT_CHAT}/viewers/join`,
};
